import api from '~/api'

export const MIN_SEARCH_LENGTH = 5
export const SEARCH_DEBOUNCE_MS = 1000

export const PROVIDER = {
  here: 'here',
  google: 'google',
  empty: 'semResultado',
  error: 'erro',
}

function getAddress(components, type, size) {
  return components.filter(({ types }) => types.find((el) => type.includes(el)))?.[0]?.[size] || ''
}

function mapGoogleResult({ formatted_address, place_id, address_components, geometry: { location } }) {
  return {
    label: formatted_address,
    locationId: place_id,
    location,
    address: {
      country: getAddress(address_components, 'country', 'long_name'),
      state: getAddress(address_components, 'administrative_area_level_1', 'short_name'),
      city: getAddress(address_components, ['locality', 'administrative_area_level_2'], 'long_name'),
      postalCode: getAddress(address_components, 'postal_code', 'long_name'),
    },
  }
}

async function searchGoogle(query) {
  const { results = [] } = await api.fetchGeoCodeGoogle(query)
  const options = results.map(mapGoogleResult)

  return { options, provider: options.length ? PROVIDER.google : PROVIDER.empty, isNoOptions: true }
}

export async function searchAddressOptions(query, searchHere) {
  const options = await searchHere(query)

  if (options.length === 0) return searchGoogle(query)

  return { options, provider: PROVIDER.here, isNoOptions: false }
}
